import InerteDeclarationAnnuelleController from './inerte.declaration.annuelle.controller';

export default {
    template: require('./inerte.declaration.annuelle.html'),
    controller: InerteDeclarationAnnuelleController
};
